import React from 'react'

import { TabelaColuna } from 'src/componentes'

export const colunaCidade = (): TabelaColuna => ({
  Chave: 'cidade',
  ComOrdenacao: true,
  RenderizarCabecalho: () => <div style={{ width: 200 }}>Cidade</div>
})
